import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import RubiksLoader from "@/components/RubiksLoader";

const ProtectedRoute = ({ children, roles }) => {
    const { user, loading } = useAuth();
    if (loading) {
        return <RubiksLoader fullScreen size={120} />;
    }
    if (!user) return <Navigate to="/login" replace />;
    if (roles && !roles.includes(user.role)) {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
};

export default ProtectedRoute;
